<template>
  <div class="list-container">
    <div v-show="!dialogFormVisible">
      <div class="filter-container">
        <template v-if="!isFilterCollapse">
          <div class="filter-box">
            <span class="label">采购编号</span>
            <el-input
              v-model="listQuery.no"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">发票号码</span>
            <el-input
              v-model="listQuery.invoiceNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">发票代码</span>
            <el-input
              v-model="listQuery.invoiceCode"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">供应商</span>
            <el-input
              v-model="listQuery.supplier"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">开票状态</span>
            <el-select :filterable="true" v-model="listQuery.invoiceStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in invoiceStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">付款状态</span>
            <el-select :filterable="true" v-model="listQuery.paymentStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in paymentStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">入库状态</span>
            <el-select :filterable="true" v-model="listQuery.storageStatus" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
              <el-option
                v-for="item in storageStatusOptions"
                :key="item.id"
                :label="item.mark"
                :value="item.id"
              />
            </el-select>
          </div>
          <div class="filter-box">
            <span class="label">材料编号</span>
            <el-input
              v-model="listQuery.materialNo"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料品牌</span>
            <el-input
              v-model="listQuery.materialBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料名称</span>
            <el-input
              v-model="listQuery.materialName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">材料型号</span>
            <el-input
              v-model="listQuery.materialModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
          </div>
          <div class="filter-box">
            <span class="label">登记时间</span>
            <el-date-picker
              v-model="listQuery.startTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.endTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">开票时间</span>
            <el-date-picker
              v-model="listQuery.invoiceStartTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.invoiceEndTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">付款时间</span>
            <el-date-picker
              v-model="listQuery.payStartTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
          <div class="filter-box">
            <span class="label">到</span>
            <el-date-picker
              v-model="listQuery.payEndTime"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD"
              @change="handleFilter"
              :size="t('table.btnSize')"
            >
            </el-date-picker>
          </div>
        </template>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t('table.search') }}
          </el-button>
          <el-button
            v-waves
            v-permission="{ pkey: `${permissionName}_DJ` }"
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('batchDengji')"
          >
            批量发票登记
          </el-button>
          <el-button
            v-permission="{ pkey: `${permissionName}_ADD` }"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t('table.add') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t('table.reset') }}
          </el-button>
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="isFilterCollapse = !isFilterCollapse"
          >
            {{ isFilterCollapse ? '展开' : '收起' }}
          </el-button>
          <span class="svg-icon cursor mr-10 ml-10" @click="handleCommand('refresh')">
                <i class="icon-tubiao-27 iconfont"/>
          </span>
          <span class="svg-icon cursor" @click="handleCommand('column')">
                <i class="icon-tubiao-28 iconfont"/>
          </span>
          <span class="ml-10 filter-mark">
            <span class="status-item"><span class="status-square" style="background-color: red;"></span><span class="status-text">待开票、部分开票</span></span>
          </span>
        </div>
      </div>
      <grid-layout
        v-model:layout="layouts"
        :col-num="12"
        :row-height="rowHeight"
        :is-draggable="false"
        :is-resizable="true"
        :is-mirrored="false"
        :vertical-compact="true"
        :margin="[10, 10]"
        :use-css-transforms="false"
      >
        <grid-item
          v-for="(item, index) in layouts"
          :x="item.x"
          :y="item.y"
          :w="item.w"
          :h="item.h"
          :i="item.i"
          :key="item.i"
          :minW="item.minW"
          :maxW="item.maxW"
          :minH="item.minH"
          :static="item.static"
          @resize="handleResizedEvent"
          @resized="handleResizedEvent">
          <template v-if="index === 0">
            <TableList
              :ref="rf => { if (rf) tableDataRef[index] = rf }"
              v-loading="listLoading"
              :dataList="list"
              :total="total"
              :columnAllData="columnAllData"
              :tableName="TableName"
              :permissionName="permissionName"
              :showSelection="true"
              :isShowPagination="false"
              :handleDefaultWidth="220"
              :highlightCurrentRow="true"
              :layoutHeight="true"
              :newHpx="newHpx"
              style="height:calc(100% );overflow:hidden;"
              :tableRowClassName="tableRowClassName"
              :showSummary="true"
              @row-click="handleRowClick"
              @command-change="handleCommand"
            >
              <template v-slot:operation-action="scope">
                <el-link
                  v-permission="{ pkey: `${permissionName}_DJ` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('dengji', scope.row)"
                >
                  发票登记
                </el-link>
                <el-link
                  v-permission="{ pkey: `${permissionName}_LIST` }"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('fplist', scope.row)"
                >
                  发票明细
                </el-link>
                <!-- <el-link
                  v-else
                  v-permission="{pkey:`${permissionName}_CANCEL_TICKET`}"
                  href="javascript:void(0);"
                  class="mr-10"
                  type="primary"
                  @click="handleCommand('cancel-ticket',scope.row)"
                >
                  作废
                </el-link> -->
              </template>
            </TableList>
            <el-pagination
              class="mt-20"
              v-show="total > 0"
              :total="total"
              v-model:currentPage="listQuery.page"
              :page-size="listQuery.size"
              :page-sizes="pageSizes"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next"
            />
          </template>
          <template v-if="index === 1">
            <div v-show="!isSubMenuCollapse">
              <div class="clearfix tab-title btn-container mt-10">
                <ul class="tab-title_left fl">
                  <li
                    v-for="item in tabList"
                    :key="item.id"
                    :class="{ active: activeTab === item.id }"
                    @click="handleTabClick(item)">{{ item.name }}
                  </li>
                </ul>
              </div>
              <LogisticTable :sendFlag="0" TableName="TABLE_DELIVERY_INFO" permissionName="LOGISTIC_INFO" v-if="activeTab === 1" ref="LogisticTable" :sourceId="activeId" :sourceType="6"/>
            </div>
          </template>
        </grid-item>
      </grid-layout>
    </div>
    <el-dialog
      v-if="dengjiVisible"
      v-model="dengjiVisible"
      width="1000px"
      title=""
    >
      <div class="form-title mb-10">
        <span class="label blue">采</span>
        <span class="left">采购信息</span>
      </div>
      <!-- <AccountPreview :account="activeRow.accounts" v-if="activeRow.accounts">>
        <template v-slot:content>
          <el-descriptions-item label="编号：">{{activeRow.no}}</el-descriptions-item>
          <el-descriptions-item label="采购商：">{{activeRow.supplier}}</el-descriptions-item>
          <el-descriptions-item label="总费用：">{{$currency(activeRow.fee)}}</el-descriptions-item>
          <el-descriptions-item label="是否含税：">{{activeRow.containsRate?'是':'否'}}</el-descriptions-item>
          <el-descriptions-item label="税率：">{{activeRow.rate}}</el-descriptions-item>
          <el-descriptions-item label="发票类型：">{{activeRow.invoiceType}}</el-descriptions-item>
          <el-descriptions-item label="状态：">{{activeRow.status}}</el-descriptions-item>
        </template>
      </AccountPreview> -->
      <MiniBusinessList :businessList="selectionArray" ref="miniBusinessList" :isRateVisible="false">
        <template v-slot:before>
          <el-table-column prop="no" label="采购编号" show-overflow-tooltip width="120"/>
          <el-table-column prop="supplier" label="采购商" show-overflow-tooltip width="120">
            <template #default="{ row }">
              {{ row.supplier.name }}
            </template>
          </el-table-column>
          <el-table-column prop="total" label="总费用" show-overflow-tooltip align="right" min-width="100">
            <template #default="{ row }">
              {{ $currency(row.total) }}
            </template>
          </el-table-column>
          <el-table-column prop="invoiceAmount" label="已开票费用" show-overflow-tooltip align="right" min-width="100">
            <template #default="{ row }">
              {{ $currency(row.invoiceAmount ?? 0) }}
            </template>
          </el-table-column>
          <el-table-column prop="amountFee" label="发票金额" align="right" min-width="180">
            <template #default="{ row }">
              <el-input-number v-model="row.amountFee" :precision="2" :max="ruleForm.amountFee" controls-position="right"/>
            </template>
          </el-table-column>
        </template>
        <template v-slot:after>
          <el-table-column prop="containsRate" label="是否含税" min-width="100">
            <template #default="{ row }">
              {{ row.containsRate ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column prop="rate" label="税率" min-width="100">
            <template #default="{ row }">
              {{ row.rate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column prop="invoiceType" label="发票类型" width="100" show-overflow-tooltip/>
          <!-- <el-table-column prop="status" label="状态" width="100"  show-overflow-tooltip/> -->
        </template>
      </MiniBusinessList>
      <div class="form-title mt-30 mb-10">
        <span class="label green">登</span>
        <span class="left">登记发票</span>
      </div>
      <el-form
        ref="dataForm"
        :model="ruleForm"
        :rules="rules"
        label-position="top"
        label-width="100px"
        class="mb-20"
      >
        <el-form-item label="扫码抢" prop="invoiceNumber">
          <el-input
            v-model="ruleForm.invoiceNumber"
            type="textarea"
            class="filter-item"
            @keyup.enter="handleBarCodeChange"
            style="width:700px">
          </el-input>
        </el-form-item>
        <div class="underlineForm">
          <el-form-item label="发票号码" prop="no">
            <el-input v-model="ruleForm.no" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="发票代码" prop="code">
            <el-input v-model="ruleForm.code" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <el-form-item label="发票校验码" prop="checkCode">
            <el-input v-model="ruleForm.checkCode" type="input" class="filter-item" placeholder=" "></el-input>
          </el-form-item>
          <!--          <el-form-item label="发票金额" prop="amount">-->
          <!--            <el-input-number :precision="2" v-model="ruleForm.amount" type="input" class="filter-item" placeholder=" " controls-position="right"></el-input-number>-->
          <!--          </el-form-item>-->
          <el-form-item label="开票日期" prop="date">
            <el-date-picker
              v-model="ruleForm.date"
              type="date"
              placeholder=" "
              format="YYYY-MM-DD"
              value-format="YYYY-MM-DD">
            </el-date-picker>
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dengjiVisible = false" type="danger">取消</el-button>
          <el-button
            type="primary"
            @click="handleDJ"
          >确定</el-button>
        </span>
      </template>
    </el-dialog>
    <el-dialog
      v-if="fpListVisible"
      v-model="fpListVisible"
      width="1000px"
      title=""
    >
      <!-- <div class="form-title mb-10">
        <span class="label blue" >采</span>
        <span class="left">采购信息</span>
      </div> -->
      <!-- <AccountPreview :account="activeRow.accounts" v-if="activeRow.accounts">>
        <template v-slot:content>
          <el-descriptions-item label="编号：">{{activeRow.no}}</el-descriptions-item>
          <el-descriptions-item label="采购商：">{{activeRow.supplier}}</el-descriptions-item>
          <el-descriptions-item label="总费用：">{{$currency(activeRow.fee)}}</el-descriptions-item>
          <el-descriptions-item label="是否含税：">{{activeRow.containsRate?'是':'否'}}</el-descriptions-item>
          <el-descriptions-item label="税率：">{{activeRow.rate}}</el-descriptions-item>
          <el-descriptions-item label="发票类型：">{{activeRow.invoiceType}}</el-descriptions-item>
          <el-descriptions-item label="状态：">{{activeRow.status}}</el-descriptions-item>
        </template>
      </AccountPreview> -->
      <MiniBusinessList :businessList="fpList" ref="miniBusinessList" :isRateVisible="false">
        <template v-slot:before>
          <el-table-column prop="invoiceNo" label="发票号码" show-overflow-tooltip width="120"/>
          <el-table-column prop="invoiceCode" label="发票代码" show-overflow-tooltip width="120"/>
          <el-table-column prop="invoiceCheckCode" label="发票检查码" show-overflow-tooltip width="120"/>
          <el-table-column prop="invoiceAmount" label="发票金额" show-overflow-tooltip align="right" min-width="100">
            <template #default="{ row }">
              {{ $currency(row.invoiceAmount) }}
            </template>
          </el-table-column>
          <el-table-column prop="invoiceTypeValue" label="发票类型" show-overflow-tooltip width="120"/>
          <el-table-column prop="invoiceDate" label="开票日期" show-overflow-tooltip width="120"/>
          <el-table-column prop="rate" label="税率" min-width="80">
            <template #default="{ row }">
              {{ row.rate || 0 }}%
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="登记时间" show-overflow-tooltip width="180"/>
          <el-table-column prop="createUserName" label="登记人" show-overflow-tooltip width="120"/>
        </template>
      </MiniBusinessList>
      <template #footer>
        <span class="dialog-footer">
          <el-button
            type="primary"
            @click="fpListVisible = false"
          >关闭</el-button>
        </span>
      </template>
    </el-dialog>
    <!-- <el-button type="primary" circle  @click="handleSubMenuCollapse" class="subMenuCollapseBtn"  v-if="!dialogFormVisible"> {{isSubMenuCollapse?'展开':'收起'}}</el-button> -->
  </div>
</template>

<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted, unref, nextTick, ref } from 'vue'
import { ElMessage, ElMessageBox, ElForm } from 'element-plus'
import { deleteById } from '@/apis/Dictionary'
import { batchDengjiTicket, cancelTicket } from '@/apis/Purchase'
import { UsersModel } from '@/model/userModel'
import { ArrayRowsItem } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'
import LogisticTable from '@/views/logistics/components/Table.vue'

import { TableName, permissionName } from '@/utils/enum'
import { TableField } from '@/views/purchasManage/ruku/FieldTable'
import { numberTimes, totalPriceWithoutRate, defaultDate, Today, pageVo, pageSizes } from '@/utils/index'
import { getPageList as getUrlList } from '@/apis/Form'
import MiniBusinessList from '@/views/business/businessList/MiniBusinessList.vue'

import { useI18n } from 'vue-i18n'
import mixin from '@/mixins'
import { invoiceStatusOptions, paymentStatusOptions, storageStatusOptions } from '@/constant/enumValues'
import { cloneDeep } from 'lodash'
// import AccountPreview from '@/views/business/outsourceCompany/AccountPreview/Index.vue'

export default defineComponent({
  name: 'Purchasticket',
  components: {
    TableList,
    LogisticTable,
    // AccountPreview
    MiniBusinessList
  },
  setup() {
    const { t } = useI18n()
    const dataForm = ref(ElForm)
    const tableDataRef = ref([])
    const miniBusinessList = ref(null)
    // TableField.splice(1, 0, {
    //   componentType: 'el-input',
    //   componentName: '输入框',
    //   fieldKey: 'paymentAccount',
    //   fieldName: '付款账户'
    // })

    const dataMap = reactive({
      TableName: TableName.TABLE_PURCHASE_TICKET,
      permissionName: permissionName.PURCHASE_TICKET,
      columnAllData: cloneDeep(TableField).filter((k) => !(k.fieldKey in ['virtualStorage'])),

      isFilterCollapse: false,
      activeId: 0,
      activeRate: 0,
      activeRow: {},
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        no: undefined,
        invoiceNo: undefined,
        invoiceCode: undefined,
        supplier: undefined,
        startTime: '',
        endTime: '',
        status: undefined,
        invoiceStatus: undefined,
        paymentStatus: undefined,
        storageStatus: undefined,
        payStartTime: undefined,
        payEndTime: undefined,
        invoiceStartTime: undefined,
        invoiceEndTime: undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      statusOption: [],
      salesManOption: [],

      pageSizes,
      tabList: [
        // { name: '业务信息', id: 2 },
        // { name: '物流信息', id: 1 }
        // { name: '跟踪信息', id: 3 }
      ],
      newHpx: 0,
      activeTab: 1,
      dengjiVisible: false,
      djInfoVisible: false,
      DJTableData: [],
      paymentAccountOption: [],
      selectionArray: [],
      fpList: [],
      fpListVisible: false,
      paymentStatusOptions,
      invoiceStatusOptions,
      storageStatusOptions,
      ruleForm: {
        invoiceNumber: '',
        no: '',
        code: '',
        checkCode: '',
        // amount: 0,
        date: Today
      },
      rules: {
        invoiceNumber: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        no: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }],
        code: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        // amount: [{ required: true, message: '请填写必填项', trigger: 'change' }],
        checkCode: [{
          required: false,
          message: '请填写必填项',
          trigger: 'change'
        }],
        date: [{
          required: true,
          message: '请填写必填项',
          trigger: 'change'
        }]
      },
      invoiceTypeOption: [],

      handleCommand(command: string, val?: any) {
        if (command !== 'column') {
          dataMap.activeRow = val
          dataMap.activeId = val ? val.id : 0
        }
        switch (command) {
          case 'add':
            dataMap.handleCreate()
            break
          case 'copy':
          case 'edit':
            dataMap.handleUpdate(val)
            break
          case 'delete':
            dataMap.handleDelete(val)
            break
          // case 'dengji':
          //   dataMap.activeRate = val.rate
          //   dataMap.dengjiVisible = true
          //   dataMap.ruleForm = {
          //     invoiceNumber: '',
          //     no: '',
          //     code: '',
          //     checkCode: '',
          //     amount: val.fee,
          //     date: Today
          //   }
          //   break
          case 'dengji':
          case 'batchDengji': {
            const tempArray = val ? [val] : dataMap.selectionArray
            const selectedArray = tempArray.map((kk: any) => {
              return {
                ...kk,
                invoiceAmount: kk.invoicedAmount || 0,
                amountFee: (kk.total ?? 0) - (kk.invoicedAmount ?? 0)
              }
            })
            dataMap.selectionArray = selectedArray
            if (!tempArray.length) {
              return ElMessage.error({
                message: '请选择数据',
                duration: 1000
              })
            }
            const firstItem = tempArray[0]
            const sameFiled = [{
              key: 'supplier',
              name: '供应商',
              targetField: 'name'
            }, {
              key: 'containsRate',
              name: '税率'
            }, {
              key: 'rate',
              name: '税率'
            }, {
              key: 'invoiceType',
              name: '发票类型'
            }]
            for (let i = 0; i < tempArray.length; i++) {
              const item = tempArray[i]
              for (let j = 0; j < sameFiled.length; j++) {
                const kk = sameFiled[j]
                const itemName = kk.targetField ? item[kk.key][kk.targetField] : item[kk.key]
                const firstItemName = kk.targetField ? firstItem[kk.key][kk.targetField] : firstItem[kk.key]
                if (itemName !== firstItemName) {
                  return ElMessage.error({
                    message: `请选择同一个${kk.name}数据`,
                    duration: 1000
                  })
                }
              }
            }
            dataMap.activeRate = firstItem.rate
            dataMap.dengjiVisible = true
            dataMap.ruleForm = {
              invoiceNumber: '',
              no: '',
              code: '',
              checkCode: '',
              // amount: selectedArray.map(item => item.amountFee).reduce((prev: number, curr: number) => prev + curr, 0),
              date: Today
            }
          }
            break
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            (tableDataRef.value[0] as any).setColumnVisible = true
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'cancel-ticket':
            dataMap.cancelTicket(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
          case 'fplist':
            getUrlList(`purchase/details/${val.id}/actions/invoice`).then((res: any[]) => {
              dataMap.fpList = res || []
              dataMap.fpListVisible = true
            })
            break
        }
      },
      getList() {
        const {
          startTime,
          endTime
        } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0
        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getUrlList('purchase/page/v2', {
          ...dataMap.listQuery,
          pageType: 3
        }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((k: any) => {
              k.supplierAccount = k.supplierAccount || {}
              return {
                ...k,
                supplierAccountName: k.supplierAccount.name,
                supplierAccountType: k.supplierAccount.type,
                supplierAccountBranchName: k.supplierAccount.branchName,
                supplierAccount: k.supplierAccount.account,
                feeWithoutRate: 0,
                totalPrice: dataMap.totalPriceWithoutRate(k.fee, k.amount, true, k.rate),
                totalPriceWithRate: dataMap.numberTimes(k.fee, k.amount, true)
              }
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      numberTimes: (price: any, amount: any, isCurrency: boolean) => numberTimes(price, amount, isCurrency),
      totalPriceWithoutRate: (price: any, amount: any, isCurrency: boolean, rate: any) => totalPriceWithoutRate(price, amount, isCurrency, rate),
      handleReset() {
        dataMap.listQuery = {
          no: undefined,
          invoiceNo: undefined,
          invoiceCode: undefined,
          supplier: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          invoiceStatus: undefined,
          paymentStatus: undefined,
          storageStatus: undefined,
          payStartTime: undefined,
          payEndTime: undefined,
          invoiceStartTime: undefined,
          invoiceEndTime: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCreate() {
        dataMap.activeId = 0
        dataMap.dialogFormVisible = true
      },
      handleUpdate(row: any) {
        dataMap.activeId = row.id
        dataMap.dialogFormVisible = true
      },
      handleBarCodeChange() {
        // 01,10,031002000411,51548062,924.53,20211223,62768369661843286906,92A4
        const value = dataMap.ruleForm.invoiceNumber
        const code = value.split(',') || []
        dataMap.ruleForm.no = code[2]
        dataMap.ruleForm.code = code[3]
        dataMap.ruleForm.checkCode = code[6]
        // const amount = Number(code[4])
        // dataMap.ruleForm.amount = Math.floor(amount * ((Number(dataMap.activeRate) + 100) / 100))
        dataMap.ruleForm.date = `${code[5].slice(0, 4)}-${code[5].slice(4, 6)}-${code[5].slice(6, 8)}`
      },
      handleDJ() {
        const form = unref(dataForm)
        form.validate(async(valid: any) => {
          if (valid) {
            try {
              const tabelArray = (miniBusinessList.value as any).businessList
              let invoiceType = null
              const ticketArray = tabelArray.map((kk: any) => {
                invoiceType = dataMap.invoiceTypeOption.find((jj: any) => {
                  return kk.invoiceType === jj.mark
                })?.id
                return {
                  amount: kk.amountFee * 1,
                  id: kk.id
                }
              })
              await batchDengjiTicket({
                no: dataMap.ruleForm.no,
                invoiceType,
                code: dataMap.ruleForm.code,
                checkCode: dataMap.ruleForm.checkCode,
                date: dataMap.ruleForm.date,
                tickets: ticketArray
              })
              dataMap.getList()
              ElMessage({
                message: '提交成功',
                type: 'success',
                duration: 1000
              })
              dataMap.dengjiVisible = false
            } catch (err: any) {
              console.log(err)
            }
          }
        })
      },
      handleDelete(row: any) {
        ElMessageBox.confirm(
          '确定要删除选中数据吗？',
          '删除',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            deleteById('invoice', row.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '删除成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      handleSubmit() {
        dataMap.getList()
      },
      handleResolveTempData(tempModel: any) {
        const { model } = tempModel
        tempModel.model = model ? model.join(',') : ''
      },
      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      handleTabClick(item: any) {
        dataMap.activeTab = item.id
      },
      handleResizedEvent(i: any, newH: any, newW: any, newHPx: any) {
        dataMap.newHpx = newHPx
      },
      handleRowClick(row: any) {
        dataMap.activeId = row.id
      },
      clearValidate() {
        nextTick(() => {
          (dataForm.value as typeof ElForm).clearValidate()
        })
      },
      cancelTicket(val: any) {
        ElMessageBox.confirm(
          '确定要作废此采购发票？',
          '作废发票',
          {
            confirmButtonText: t('table.confirm'),
            cancelButtonText: t('table.cancel'),
            type: 'warning',
            cancelButtonClass: 'el-button--danger'
          }
        )
          .then(() => {
            cancelTicket(val.id).then(() => {
              dataMap.getList()
              ElMessage({
                message: '作废成功',
                type: 'success',
                duration: 1000
              })
            })
          })
      },
      tableRowClassName({ row }: any) {
        const obj = {
          待开票: 'row-red',
          部分开票: 'row-red'
        }
        return obj[row.invoiceStatusValue]
      }
    })
    const { mixinData } = mixin(dataMap)

    onMounted(() => {
      mixinData.initHeight()

      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      getUrlList('/paymentAccount/page?page=1&size=100').then((res: any) => {
        dataMap.paymentAccountOption = res.data || []
      })
      getUrlList('dropdown/InvoiceType').then((res: any) => {
        dataMap.invoiceTypeOption = res || []
      })
    })
    return {
      t,
      ...toRefs(dataMap),
      ...toRefs(mixinData),
      dataForm,
      tableDataRef,
      miniBusinessList
    }
  }
})
</script>
<style lang="scss">

</style>
